"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.asAnd = exports.JoinCondition = void 0;
const join_type_1 = require("./join-type");
const Model = __importStar(require("./index"));
const condition_1 = require("./condition");
const _ = __importStar(require("lodash"));
class JoinCondition extends condition_1.Condition {
    constructor() {
        super(...arguments);
        this.joinType = join_type_1.JoinType.AND;
        this.conditions = [];
        this.negate = false;
    }
    add(conditionType) {
        let ConditionModel = _.get(Model, `${conditionType}`, JoinCondition);
        let newCondition = new ConditionModel();
        this.conditions.push(newCondition);
        return newCondition;
    }
    addCondition(condition) {
        this.conditions.push(condition);
    }
    remove(condition) {
        _.remove(this.conditions, (c) => c === condition);
    }
}
exports.JoinCondition = JoinCondition;
function asAnd(...conditions) {
    let joinCondition = new JoinCondition();
    joinCondition.conditions = conditions;
    return joinCondition;
}
exports.asAnd = asAnd;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/join-condition.js
// module id = 1214
// module chunks = 0